// extracted by mini-css-extract-plugin
module.exports = {"host":"CardAnnotation_host__AfX_c","comboVariant":"CardAnnotation_comboVariant__2A_1q"};